import {
  BasketColumn,
  BasketColumnKeys,
} from 'graphql-api/baskets-api-interfaces';

const invisibleColumns = [
  BasketColumnKeys.DisplayDateFrom,
  BasketColumnKeys.DeliveryDate,
  BasketColumnKeys.Markup,
  BasketColumnKeys.Wsp,
  BasketColumnKeys.Rrp,
  BasketColumnKeys.OrderType,
  BasketColumnKeys.ProductId,
  BasketColumnKeys.Gender,
];

const shouldBeInvisible = (column: BasketColumn) =>
  invisibleColumns.includes(column.key);

export const hideProductLineColumnsInHeader = (
  headerColumns: BasketColumn[],
): BasketColumn[] => {
  return headerColumns.map((column) => ({
    ...column,
    hidden: shouldBeInvisible(column),
  }));
};
